var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flicking',{attrs:{"options":{
    align: 'prev',
    bound: false,
    panelsPerView: 2,
    circular: false,
    resizeOnContentsReady: true,
    preventClickOnDrag: true
  },"plugins":_vm.plugins}},[_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"card-panel mx-3 cursor-pointer",class:{'active': _vm.activeItemValue == item.id},on:{"click":function($event){return _vm.handleClick(item.id)}}},[_c('img',{staticClass:"h-100 w-100 object-cover",attrs:{"src":item.picture,"alt":item.id}})])}),_vm._v(" "),_c('span',{staticClass:"flicking-arrow-prev is-thin",attrs:{"slot":"viewport"},slot:"viewport"}),_vm._v(" "),_c('span',{staticClass:"flicking-arrow-next is-thin",attrs:{"slot":"viewport"},slot:"viewport"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22085a94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/FlickerCarousel.vue
// module id = 1935
// module chunks = 5